import React from "react";
import styled from "styled-components";
import { StatusIndicator, Text, DropDown } from "@flexisaf/flexibull2";
import Theme from "../../../theme";
import { MONTH_NAMES } from "../../../utils/constants";

const CardContainer = styled.div`
  background: #f1f1f17d;

  & .card-header {
    background: #fff;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    padding: 0.5rem 1rem;
    & img {
      border-radius: 50%;
      width: 50px;
      height: 50px;
    }
    & .exam-title {
      p:first-of-type {
        font-size: 1rem;
      }
    }
  }
  & .content-wrapper {
    display: flex;
    flex-direction: column;
    padding: 2rem 0;
    & .tag {
      width: min-content;
      margin: 0 auto;
    }
    & .card-body {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-evenly;

      padding: 1rem 0;

      & p > span {
        font-weight: bold;
      }
    }
    & .card-footer {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      gap: 2rem;
    }
  }
`;

export const ExamsCardList = ({
  handleRedirect,
  handleEdit,
  handleDelete,
  examData,
  examCount,
  subjectCount,
}) => {
  const { name, year, month } = examData;
  const date = `${year}-${month + 1}`;

  const modYear = new Date(date).getFullYear();
  const modMonth = new Date(date).getMonth();

  return (
    <CardContainer>
      <div className="card-header">
        <p>{name}</p>
        <DropDown
          label={
            <Text bold size="14px" style={{ cursor: "pointer" }}>
              ...
            </Text>
          }
          menuAlign="bottom right"
          trigger="click"
          menuList={[
            {
              onClick: () => handleEdit(),
              label: "Edit Exam",
              iconLeft: "saf-receipt-edit",
            },
            {
              onClick: () => handleDelete(),
              label: "Delete Exam",
              color: Theme.PrimaryRed,
              iconLeft: "saf-trash",
            },
          ]}
        />
      </div>
      <div
        style={{ cursor: "pointer" }}
        onClick={handleRedirect}
        className="content-wrapper"
      >
        <div className="tag">
          <StatusIndicator
            compound
            label={examData?.isActive ? "Active" : "Inactive"}
            color={examData?.isActive ? Theme.PrimaryGreen : Theme.PrimaryRed}
          />
        </div>
        <div className="card-body">
          {date && date !== "undefined" ? (
            <p>
              <span> Month:</span> {MONTH_NAMES[modMonth]}
            </p>
          ) : null}
          {date && date !== "undefined" ? (
            <p>
              <span> Year:</span> {modYear}
            </p>
          ) : null}
        </div>

        <div className="card-footer">
          <p>{examData.paperCount || 0} Paper{examData.paperCount !== 1 && 's'}</p>
          {subjectCount && <p>{`${subjectCount || 0} Subjects`}</p>}
        </div>
      </div>
    </CardContainer>
  );
};
